import React from 'react';
import Instagram from "../../../assets/icons/instagram.png";
import Linkedin from "../../../assets/icons/LinkedIn.png";
import Twitter from "../../../assets/icons/twitter.png";
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <h3>EMIfy</h3>
          <p>
            Automating Payment Collections And Reconciliation <br />
            For Smarter, Faster, And Secure Transactions
          </p>
        </div>

        <div className={styles.linksSection}>
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#careers">Careers</a></li>
            <li><a href="#about">About</a></li>
          </ul>
        </div>

        <div className={styles.helpSection}>
          <h4>Need Help?</h4>
          <ul>
            <li><a href="#terms">Terms & Conditions</a></li>
            <li><a href="#privacy">Privacy Policy</a></li>
            <li><a href="#support">Help & Support</a></li>
          </ul>
        </div>

        <div className={styles.socialSection}>
          <h4>Social Media</h4>
          <ul>
            <li>
              <a href="#linkedin">
                <img src={Linkedin} alt="LinkedIn" className={styles.icon} />
                LinkedIn
              </a>
            </li>
            <li>
              <a href="#instagram">
                <img src={Instagram} alt="Instagram" className={styles.icon} />
                Instagram
              </a>
            </li>
            <li>
              <a href="#twitter">
                <img src={Twitter} alt="Twitter" className={styles.icon} />
                Twitter
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>© Copyright | EMIfy | 2025</p>
      </div>
    </footer>
  );
};

export default Footer;
